<template>
  <div class="container how-pandemic-affected">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="16" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip skip="catchcovid19">
    </back-and-skip>
    <div class="row pt-4 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/pandemic_affected.svg" alt="pandemic-affected">
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('pandemicAffected.title') }}
        </label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="offset-2 col-8 offset-lg-3 col-lg-6 text-center text-wrap pl-0 pr-0">
        <label class="note">
          {{ $t('pandemicAffected.note') }}
        </label>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-2 col-lg-4 text-center">
        <button class="btn btn-lg option-button"
          v-bind:class="areas['work'] > 0?'option-button-fill':'option-button'"
          @click="show('work')">
          {{ $t('pandemicAffected.work')}}
          <label v-if="areas['work'] > 0">
            ({{ areas['work'] }})
          </label>
        </button>
      </div>
      <div class="col-6 col-lg-4">
        <button class="btn btn-lg option-button"
          v-bind:class="areas['mental_health'] > 0?'option-button-fill':'option-button'"
          @click="show('mental_health')">
          {{ $t('pandemicAffected.mentalHealth')}}
          <label v-if="areas['mental_health'] > 0">
            ({{ areas['mental_health'] }})
          </label>
        </button>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-2 col-lg-4 text-center">
        <button class="btn btn-lg option-button"
          v-bind:class="areas['social_life_friendship'] > 0?'option-button-fill':'option-button'"
          @click="show('social_life_friendship')">
          {{ $t('pandemicAffected.family')}}
          <label v-if="areas['social_life_friendship'] > 0">
            ({{ areas['social_life_friendship'] }})
          </label>
        </button>
      </div>
      <div class="col-6 col-lg-4">
        <button class="btn btn-lg option-button"
          v-bind:class="areas['finances'] > 0?'option-button-fill':'option-button'"
          @click="show('finances')">
          {{ $t('pandemicAffected.finances')}}
          <label v-if="areas['finances'] > 0">
            ({{ areas['finances'] }})
          </label>
        </button>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-2 col-lg-4 text-center">
        <button class="btn btn-lg option-button"
          v-bind:class="areas['lost_anybody'] > 0?'option-button-fill':'option-button'"
          @click="show('lost_anybody')">
          {{ $t('pandemicAffected.lostSomeone')}}
          <label v-if="areas['lost_anybody'] > 0">
            ({{ areas['lost_anybody'] }})
          </label>
        </button>
      </div>
      <div class="col-6 col-lg-4">
        <button class="btn btn-lg option-button"
          v-bind:class="areas['physical_health'] > 0?'option-button-fill':'option-button'"
          @click="show('physical_health')">
          {{ $t('pandemicAffected.physicalHealth')}}
          <label v-if="areas['physical_health'] > 0">
            ({{ areas['physical_health'] }})
          </label>
        </button>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg option-button"
          v-bind:class="areas['not_at_all'] > 0?'option-button-fill':'option-button'"
          @click="show('not_at_all')">
          {{ $t('pandemicAffected.notAtAll')}}
        </button>
      </div>
    </div>
    <div class="row pt-3 pb-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('general.next') }}
        </button>
      </div>
    </div>
    <modal name="range"
      :adaptive='true'
      height="auto"
      :scrollable='true'
      :reset='true'>
      <div class="container">
        <div class="row pt-4">
          <div class="col-12 text-center">
            <label class="title">
              {{ $t('pandemicAffected.rangeInfo') }}
            </label>
          </div>
        </div>
        <div class="row pt-4 pb-4">
          <div class="col-12">
            <vue-slider v-model="areas[field]"
              :min="0"
              :max="10"
              :interval="1"
              :dotSize="18">
            </vue-slider>
          </div>
        </div>
        <div class="row pt-2 pb-2">
          <div class="col-12 text-center">
            <button class="btn btn-sm text-light done" @click="cancel">
              {{ $t('general.done') }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import BackAndSkip from '../components/BackAndSkip.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  data () {
    return {
      value: 0,
      areas: {
        'work': 0,
        'mental_health': 0,
        'social_life_friendship': 0,
        'finances': 0,
        'lost_anybody': 0,
        'physical_health': 0,
        'not_at_all': 0
      },
      field: ''
    }
  },
  components: {
    BackAndSkip,
    VueSlider
  },
  methods: {
    show (value) {
      if (value !== 'not_at_all') {
        this.field = value

        this.$modal.show('range')
      } else if (value === 'not_at_all') {
        this.areas['not_at_all'] = 1
      }
    },
    cancel () {
      this.$modal.hide('range')
    },
    atLeastOne () {
      for (const [name, value] of Object.entries(this.areas)) {
        if (value > 0) {
          return true
        }
      }

      return false
    },
    next () {
      if (!this.atLeastOne()) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: this.$t('general.oneItemError')
        })
      } else {
        for (const [name, value] of Object.entries(this.areas)) {
          let answer = {
            key: 'how_pandemic_affected_' + name,
            value: value
          }

          this.$store.commit('SET_DATA_SURVEY', answer)
        }

        this.$router.push({
          name: 'catchcovid19'
        })
      }
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'howpandemicaffected')
  }
}
</script>

<style>
.how-pandemic-affected .img-question {
  width: 100%;
  height: 22vh;
}

.how-pandemic-affected .title {
  font-weight: 700;
  font-size: 1.1rem;
}

.how-pandemic-affected .note {
  font-size: .9rem;
}

.how-pandemic-affected .option-button {
  color: #2bb1c4;
  border: 1px solid #2bb1c4;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding-left: 0;
  padding-right: 0;
  font-size: 1rem;
  padding-top: .8rem;
  padding-bottom: .8rem;
}

.how-pandemic-affected .option-button-fill {
  color: #fff;
  background-color: #2bb1c4;
  border: 1px solid #2bb1c4;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding-left: 0;
  padding-right: 0;
  font-size: 1rem;
  padding-top: .8rem;
  padding-bottom: .8rem;
}

.how-pandemic-affected .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

.how-pandemic-affected .done {
  width: 75%;
  min-height: 60px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

@media screen and (device-aspect-ratio: 40/71) {
  .how-pandemic-affected .img-question {
    width: 100%;
    height: 18vh;
  }

  .how-pandemic-affected .title {
    font-size: 1rem;
  }

  .how-pandemic-affected .note {
    font-size: .7rem;
  }

  .how-pandemic-affected .option-button {
    font-size: .85rem;
    padding-top: .4rem;
    padding-bottom: .4rem;
  }

  .how-pandemic-affected .next {
    min-height: 70px;
  }
}
</style>
